export default __webpack_public_path__ + "static/media/T09C.7e094cfb.png";